<template>
  <div v-wechat-title="titleTop">

      <div class="topIcon">
        <i class="iconfont iconsuccess"/>
      </div>
      <div class="title1">投诉已提交</div>
      <div class="title2">你的投诉已提交，投诉结果将会在3-5个工作日通<br>过由邮件方式反馈给你</div>

  </div>
</template>
<script>
import request from '@/utils/request'
import TopBar from '@/components/TopBar'
import { Uploader, Button, Popup, Field, Toast,RadioGroup, Radio,Checkbox ,Picker } from 'vant'
import { getUrlKey,compressorImageList, GetEnumList, MyNotify, GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import FieldSelect from '@/components/FieldSelect'
import wxShare from '@/components/wxShare'
import { GetSelfUrl } from '@/utils/request'

export default {
  components: {
    [Uploader.name]: Uploader,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [Toast.name]: Toast,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Checkbox.name]: Checkbox,
    [Picker.name]: Picker,
    TopBar,
    FieldSelect,
    wxShare
  },
  props: {
    // eslint-disable-next-line
    value:undefined,
  },
  data() {
    return {
      system:'',
      titleTop: '酷潜品质管理',
      showShare: false,
      shareTitle: '',
      shareAbout: '',
      shareTimeline: '',
      shareUrl: '',
      shareIcon: ''
    }
  },
  watch: {
    
  },
  created() {
    this.system = getUrlKey('system')
    setTimeout(() => {
      this.title = GetSysTitle()
      this.shareAbout = ''
      this.shareTitle = '酷潜品质管理'
      this.shareTimeline = '酷潜品质管理'
      this.shareUrl = undefined
      this.shareUrl = GetSelfUrl() + 'my/complaintnew?system=' +this.system
      this.shareIcon = GetSelfUrl() + 'img/complaintnew.jpg'
    }, 100)
  },
  methods: {
    GetEnumList,
    MyNotify,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    onShareFinish() {
      this.shareUrl = undefined
    },
  }
}
</script>

<style scoped>

.topIcon{
  margin-top: 20vh;
  text-align: center;
  margin-left: calc(50vw - 1.25em);
  height: 2.5em;
  line-height: 2.5em;
  width: 2.5em;
  border-radius: 2.5em;
  background-color: #00B83E;
  color: #fff;
}
.topIcon i{
  font-size: 2em;
}
.title1{
  margin:1em 0;
  text-align: center;
  font-weight: 700;
}
.title2{
  text-align: center;
  font-size: 0.8em;
  color: #999;
}
</style>
